// extracted by mini-css-extract-plugin
var _1 = "EditableStyles-module__accept-button___cD2YQ";
var _2 = "EditableStyles-module__accept-button___cD2YQ";
var _3 = "EditableStyles-module__editable___czlxp";
export { _1 as "accept-button", _2 as "acceptButton", _3 as "editable" }
